import React from 'react';

import { IIconArrowLeft } from './types';

const IconArrowLeft: React.FC<IIconArrowLeft> = props => (
  <svg viewBox="0 0 20 16" {...props}>
    <path
      d="M19,7H3.4l5.3-5.3c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-7,7C0.1,7.5,0,7.7,0,8s0.1,0.5,0.3,0.7l7,7
	C7.5,15.9,7.7,16,8,16s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4L3.4,9H19c0.6,0,1-0.4,1-1S19.5,7,19,7z"
    />
  </svg>
);

IconArrowLeft.defaultProps = {
  fill: Styles.color.primary
};

export default IconArrowLeft;
